// MessageModel.ts
import { TypeRoleEnum } from "./TypeRoleEnum";

export enum MessageTypeEnum {
  TEXT = "TEXT",
  LOCATION = "LOCATION",
  AUDIO = "AUDIO",
  VIDEO = "VIDEO",
  DOCUMENT = "DOCUMENT",
  STICKER = "STICKER",
  CONTACTS = "CONTACTS",
  REACTION = "REACTION",
  TOOL = "TOOL",
  INFO = "INFO",
  IMAGE = "IMAGE",
  UNKNOWN = "UNKNOWN",
  INTERACTIVE = "INTERACTIVE",
  SYSTEM = "SYSTEM",
}

export class MessageModel {
  id?: string;
  whatsappMessageId?: string;
  companyId?: string;
  phoneNumber?: string;
  serviceCode?: string;
  sourceMessageId?: string;
  content: string;
  role: TypeRoleEnum;
  createdAt: Date;
  sourceCreatedAt?: Date | null;
  status: "pending" | "sent" | "delivered" | "read" | "failed";
  messageType: MessageTypeEnum;
  contentMetadata?: string | Record<string, any>;
  name?: string;

  constructor(data: any) {
    this.id = data.id;
    this.whatsappMessageId = data.whatsappMessageId;
    this.companyId = data.companyId;
    this.phoneNumber = data.phoneNumber;
    this.serviceCode = data.serviceCode;
    this.sourceMessageId = data.sourceMessageId;
    this.content = data.content;
    this.role = data.role;
    this.createdAt = data.createdAt || new Date();
    this.sourceCreatedAt = data.sourceCreatedAt || null;
    this.messageType = data.messageType || MessageTypeEnum.TEXT;
    this.contentMetadata = data.contentMetadata;
    this.name = data.name;
    this.status = data.status || "sent";
  }
}
